import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import ReactModal from "react-modal";
import { scroller } from "react-scroll";
import logoProject from "./logo-project.svg";
import homeList from "./../../shared/content/homeType.json";
import zoneList from "./../../shared/content/homeZone.json";

import { useLocation } from 'react-router-dom';

import {
  CardHomeType,
  CardHomeItem,
  HomeDetail,
} from "./../../shared/components";

const Container = styled.div`
  max-width: 1248px;
  width: 100%;
  padding: 0;
  margin: 0 auto;
`;
const VDOContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  margin-bottom: 30px;
  & iframe {
    position: relative;
    width: 768px;
    height: 420px;
  }
  @media only screen and (max-width: 600px) {
    & iframe {
      position: relative;
      width: 100%;
      height: 280px;
    }
  }
`;
const LogoContainer = styled.div`
  margin-bottom: 30px;
  padding: 0 1rem;
  & .the-neighbours-logo {
    height: 80px;
  }
`;

const HomeTypeContainer = styled.div`
  padding: 0 1rem;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
`;

const HomeZoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  padding-top: 30px;
  padding: 0 1rem;
  padding-bottom: 30px;
  text-align: left;
`;

const HomeZoneListContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
`;
const Home = (props) => {
  const modalRef = useRef();
  const {search,hash} = useLocation();
  const scroll    = scroller.animateScroll;
  const [detailId, setDetailId] = useState(hash.replace("#",""));
  const [isOpen, setIsOpen] = useState(hash != "");
  useEffect(() => {
    setDetailId(hash.replace("#",""));
    setIsOpen(false);
    if(hash.replace("#","") != ""){
      setIsOpen(true);
      scroller.scrollTo("card-home-detail", {
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
        containerId: "ReactModalId",
        offset: -150
      })
    }
  },[hash]);
  
  return (
    <>
      <ReactModal
        ref={modalRef}
        id={"ReactModalId"}
        isOpen={isOpen}
        shouldFocusAfterRender={true}
        style={{
          overlay: {
            zIndex: 1,
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.75)",
          },
          content: {
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "0",
            outline: "none",
            padding: "0",
            zIndex: 2,
          },
        }}
      >
        <HomeDetail ref={modalRef} onCloseModal={(bool) => setIsOpen(bool)} id={detailId} />
      </ReactModal>
      <Container className="main-content">
        <VDOContainer>
          <iframe
            src="https://www.youtube.com/embed/oCam-TI5EIs?controls=0"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </VDOContainer>
        <LogoContainer>
          <img src={logoProject} className="the-neighbours-logo" alt="logo" />
        </LogoContainer>

        <HomeTypeContainer>
          {homeList.map((home) => (
            <CardHomeType data={home} />
          ))}
        </HomeTypeContainer>
      </Container>
      <HomeZoneContainer>
        <Container>
          {zoneList.map((zone) => (
            <>
              <h3 style={{ margin: "20px 0" }}>{zone.zone_name}</h3>
              <HomeZoneListContainer>
                {zone.home.map((home) => (
                  <CardHomeItem data={home} />
                ))}
              </HomeZoneListContainer>
            </>
          ))}
        </Container>
      </HomeZoneContainer>
    </>
  );
};

export default Home;
